import { ApiMatch } from '../api-types/match.api';
import { Match } from '../app-types/match.app';

export const transformApiMatchToMatch = (input: ApiMatch): Match => {
	return {
		id: input.id,
		name: input.name,
	};
};
